const URL = window.URL || window.webkitURL;
export default URL;
